import React from 'react';
import { Typography } from 'antd';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
    Cell,
} from 'recharts';
import styled from 'styled-components';

const { Title } = Typography;

const ChartCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  height: 100%;
`;

const SpecialtiesChart = ({ data }) => {
    // Logic from main component
    const specialtyStats = (data?.specialtyDistribution || []).slice(0, 4).map((spec, i) => ({
        name: spec.name,
        click: spec.clicks ?? Math.floor(spec.value * 1.5), // Use backend clicks or simulate
        impression: spec.impressions ?? Math.floor(spec.value * 2.1), // Use backend impressions or simulate
    }));

    const displayData = specialtyStats.length > 0 ? specialtyStats : [];

    return (
        <ChartCard>
            <Title level={5} style={{ marginBottom: 30, color: '#334155' }}>Especialidades Médicas</Title>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={displayData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                    <XAxis dataKey="name" axisLine={false} tickLine={false} />
                    <YAxis axisLine={false} tickLine={false} />
                    <Tooltip cursor={{ fill: '#f1f5f9' }} />
                    <Legend verticalAlign="top" align="right" iconType="rect" />
                    <Bar dataKey="click" name="Clicks" fill="#4f46e5" radius={[4, 4, 0, 0]} barSize={40}>
                        {displayData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={index === 2 ? '#4f46e5' : '#e2e8f0'} />
                        ))}
                    </Bar>
                    <Bar dataKey="impression" name="Impression" fill="#e2e8f0" radius={[4, 4, 0, 0]} barSize={40} />
                </BarChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};

export default SpecialtiesChart;
